import React from "react";
import back from './images/back.jpg';
import home from './images/home.jpg';
import home2 from './images/IdaBrand.jpg';

const Girls = () => {

    return(
        <div className="md:bg-cover bg-contain" style={{backgroundImage: `url(${back})`}}>

        <div className="text-center lg:text-left">
            <div className="container p-5 md:p-7 ">
                <div className="grid grid-cols-1 gap-1 md:gap-4 justify-center items-center lg:grid-cols-3 lg:px-40">
                    <div className="mb-0 md:mb-0 text-start md:text-end">
                        <p className="font-bold uppercase text-xl lg:text-3xl text-blue-800">
                            GIRLS IN CODE PROGRAM
                        </p>
                    </div>
                    <div className="mb-0 md:mb-0 lg:col-span-2 text-sm lg:text-xl text-end md:text-start">
                        <p className="md:pr-28">
                            Girls In Code is a national non-profitworking to close the gender gap intechnology.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    
        <div className="text-center lg:text-left">
            <div className="container p-5 md:p-7 ">
                <div className="grid grid-cols-1 gap-4 justify-center items-center lg:grid-cols-2 lg:px-5">
                <div className="mb-0 md:mb-0  text-small lg:text-base text-start lg:pl-40 lg:pb-20 items-center">
                        <img src={home} className="object-cover h-52 w-52 lg:h-96 lg:w-96 rounded-full" alt=""/>
                    </div>
                    <div className="mb-0 md:mb-0 text-start">
                        <div className="text-xl font-bold uppercase mb-1 md:mb-3 lg:text-3xl text-blue-800">PROGRAM PURPOSE</div>
                        <div className="font-sans text-sm lg:pr-20 lg:text-xl">Girls In Code is a national non-profit working to
                            close the gender
                            gap in technology. <br/>
                            Girls In Code Clubs in schools are led by Facilitators, who are 18+ and can be teachers,
                            computer scientists, librarians, parents, college students or volunteers from any background or
                            ﬁeld.</div>
                    </div>
                    
                </div>
            </div>
        </div>
    
        <div className="relative">
            <h1 className="text-2xl md:text-4xl font-bold tracking-tight text-blue-800 py-2 px-4 lg:px-16">TRAINING PROGRAM</h1>
                <div className="mx-auto max-w-2xl py-2 px-4 sm:py-10 sm:px-6 lg:max-w-7xl lg:px-10 ">
    
                    <div
                        className="grid grid-cols-1 gap-y-2  gap-x-2 sm:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 xl:gap-y-5 xl:gap-x-5 lg:px-5">
                        <div data-aos="zoom-in-down"
                            className=" group aspect-w-1 aspect-h-1 w-full overflow-hidden  xl:aspect-w-7 xl:aspect-h-8 bg-blue-800 border border-gray-200 rounded-lg shadow-md ">
    
                            <img src={home} alt="" />
                            <div className="p-2 text-center">
                                <h5 className="mb-2 text-xl font-bold tracking-tight text-white  ">Academic Trainings</h5>
    
                                <p className="mb-3 font-normal text-gray-300 text-sm">
                                    We provide affordable IT services and
                                    trainings, where we facilitate secondary
                                    students with their academic internships,
                                    by empowering them with solutions which
                                    will sustain and solve societys problem
                                    through coding and computer languages.
                                </p>
    
                            </div>
                        </div>
    
                        <div data-aos="zoom-in-down"
                            className=" group aspect-w-1 aspect-h-1 w-full overflow-hidden  xl:aspect-w-7 xl:aspect-h-8 bg-blue-800 border border-gray-200 rounded-lg shadow-md ">
    
                            <img src={home} alt="" />
                            <div className="p-2 text-center">
                                <h5 className="mb-2 text-xl font-bold tracking-tight text-white  ">Academic Trainings</h5>
    
                                <p className="mb-3 font-normal text-gray-300 text-sm">
                                    We provide affordable IT services and
                                    trainings, where we facilitate secondary
                                    students with their academic internships,
                                    by empowering them with solutions which
                                    will sustain and solve societys problem
                                    through coding and computer languages.
                                </p>
    
                            </div>
                        </div>
    
                        <div data-aos="zoom-in-down"
                            className=" group aspect-w-1 aspect-h-1 w-full overflow-hidden  xl:aspect-w-7 xl:aspect-h-8 bg-blue-800 border border-gray-200 rounded-lg shadow-md ">
    
                            <img src={home} alt="" />
                            <div className="p-2 text-center">
                                <h5 className="mb-2 text-xl font-bold tracking-tight text-white  ">Academic Trainings</h5>
    
                                <p className="mb-3 font-normal text-gray-300 text-sm">
                                    We provide affordable IT services and
                                    trainings, where we facilitate secondary
                                    students with their academic internships,
                                    by empowering them with solutions which
                                    will sustain and solve societys problem
                                    through coding and computer languages.
                                </p>
    
                            </div>
                        </div>
    
                        <div data-aos="zoom-in-up"
                            className=" group aspect-w-1 aspect-h-1 w-full overflow-hidden  xl:aspect-w-7 xl:aspect-h-8 bg-blue-800 border border-gray-200 rounded-lg shadow-md ">
    
                            <img  src={home} alt="" />
                            <div className="p-2 text-center">
                                <h5 className="mb-2 text-xl font-bold tracking-tight text-white  ">Academic Trainings</h5>
    
                                <p className="mb-3 font-normal text-gray-300 text-sm">
                                    We provide affordable IT services and
                                    trainings, where we facilitate secondary
                                    students with their academic internships,
                                    by empowering them with solutions which
                                    will sustain and solve societys problem
                                    through coding and computer languages.
                                </p>
    
                            </div>
                        </div>
    
                        <div data-aos="zoom-in-up"
                            className=" group aspect-w-1 aspect-h-1 w-full overflow-hidden  xl:aspect-w-7 xl:aspect-h-8 bg-blue-800 border border-gray-200 rounded-lg shadow-md ">
    
                            <img  src={home} alt="" />
                            <div className="p-2 text-center">
                                <h5 className="mb-2 text-xl font-bold tracking-tight text-white  ">Academic Trainings</h5>
    
                                <p className="mb-3 font-normal text-gray-300 text-sm">
                                    We provide affordable IT services and
                                    trainings, where we facilitate secondary
                                    students with their academic internships,
                                    by empowering them with solutions which
                                    will sustain and solve societys problem
                                    through coding and computer languages.
                                </p>
    
                            </div>
                        </div>
    
                        <div data-aos="zoom-in-up"
                            className=" group aspect-w-1 aspect-h-1 w-full overflow-hidden  xl:aspect-w-7 xl:aspect-h-8 bg-blue-800 border border-gray-200 rounded-lg shadow-md ">
    
                            <img src={home} alt="" />
                            <div className="p-2 text-center">
                                <h5 className="mb-2 text-xl font-bold tracking-tight text-white  ">Academic Trainings</h5>
    
                                <p className="mb-3 font-normal text-gray-300 text-sm">
                                    We provide affordable IT services and
                                    trainings, where we facilitate secondary
                                    students with their academic internships,
                                    by empowering them with solutions which
                                    will sustain and solve societys problem
                                    through coding and computer languages.
                                </p>
    
                            </div>
                        </div>
    
                    </div>
                </div>
    
    
                <div className="relative">
                    <h1 className="text-2xl md:text-4xl font-bold tracking-tight text-blue-800 py-1 px-2 sm:px-16 text-center">OUR GIRLS</h1>
                        <div className="mx-auto max-w-sm py-1 px-2 sm:py-10 sm:px-6 lg:max-w-7xl lg:px-10 ">
    
                            <div
                                className="grid grid-cols-1 gap-y-2  gap-x-2 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 xl:gap-y-5 xl:gap-x-5 lg:px-5">
    
    
                                <div data-aos="flip-left"
                                    className="group aspect-w-1 aspect-h-1 w-full overflow-visible  xl:aspect-w-7 xl:aspect-h-8 block  p-4 rounded-lg shadow-lg bg-white m-0 md:m-4">
                                    <div className="md:flex md:flex-row">
                                        <div
                                            className="md:w-96 w-36 flex justify-center items-center mb-6 lg:mb-0 mx-auto md:mx-0">
                                            <img src={home2}
                                                className="rounded-full shadow-md" alt="woman avatar" />
                                        </div>
                                        <div className="md:ml-6">
                                            <p className="text-gray-600 font-normal mb-6">
                                                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Id quam sapiente
                                                molestiae numquam quas, voluptates omnis nulla ea odio quia similique
                                                corrupti
                                                magnam.
                                            </p>
                                            <p className="font-semibold text-lg md:text-xl mb-2 text-blue-800">Anna Smith</p>
                                        </div>
                                    </div>
                                </div>
    
                                <div data-aos="flip-left"
                                    className="group aspect-w-1 aspect-h-1 w-full  xl:aspect-w-7 xl:aspect-h-8 block  p-4 rounded-lg shadow-lg bg-white m-0 md:m-4">
                                    <div className="md:flex md:flex-row">
                                        <div
                                            className="md:w-96 w-36 flex justify-center items-center mb-6 lg:mb-0 mx-auto md:mx-0 overflow-visible ">
                                            <img src={home2}
                                                className="rounded-full shadow-md" alt="woman avatar" />
                                        </div>
                                        <div className="md:ml-6">
                                            <p className="text-gray-600 font-normal mb-6">
                                                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Id quam sapiente
                                                molestiae numquam quas, voluptates omnis nulla ea odio quia similique
                                                corrupti
                                                magnam.
                                            </p>
                                            <p className="font-semibold text-lg md:text-xl mb-2 text-blue-800">Anna Smith</p>
                                        </div>
                                    </div>
                                </div>
    
                            </div>
                        </div>
    
                </div>
                </div>
                </div>
    
    );
};

export default Girls;